import { TenantSections } from "modules/tenants/sections";
import React, { FunctionComponent } from "react";
import { generatePath, useNavigate, useParams } from "react-router-dom";

import { TabsNav } from "@components/tabs-nav/TabsNav";

import { TenantsTabs } from "../tenants-tabs.constants";
import { TenantsList } from "./TenantsList";
import { TenantTabHeader } from "./TenantTabHeader";

const TenantTabsBase: FunctionComponent = () => {
  const { tenantId } = useParams();

  const navigate = useNavigate();

  return (
    <TabsNav<{ sectionId: string }>
      tabKey="tenants"
      selectedTab={tenantId}
      navigatePath={details => {
        return generatePath("/tenants/:tenantId/:sectionId", {
          tenantId: details.id,
          sectionId: details.sectionId ?? TenantsTabs.Platform.Details.id
        });
      }}
      defaultPath="/tenants"
      renderTab={({ id }, setSectionId) => (
        <TenantSections
          tenantId={id}
          onSectionChange={sectionId => {
            const toSectionId = sectionId || TenantsTabs.Platform.Details.id;
            const to = generatePath("/tenants/:tenantId/:sectionId", {
              tenantId: id,
              sectionId: toSectionId
            });
            setSectionId(toSectionId);
            navigate(to);
          }}
        />
      )}
      renderDefault={() => <TenantsList />}
      renderLink={({ details, isSelected }) => (
        <TenantTabHeader details={details} isSelected={isSelected} />
      )}
    />
  );
};

export const TenantTabs = () => {
  return <TenantTabsBase />;
};
